import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { instance } from "../../config/config";
import MultiStep from "react-multistep";
import Dropdown from "../../common/Dropdown";
import { AddressAutofill } from "@mapbox/search-js-react";
import Loading from "../../common/Loading";
import Button from "../../common/Button";

const Edit = () => {
  const location = useLocation();
  const id = location?.state;

  const [item, setItem] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");

  const [data, setData] = useState({
    property_type: ["TownHouse", "Apartment"],
    listing_property_type: ["Management", "Rental"],
    bedroom: [1, 2, 3, 4],
    bath: [1, 2, 3, 4],
    utility: [],
    policies: [],
    amenities: [],
    address: "",
    sqFt: 0,
    rent: 0,
    imageLink: "",
  });

  const [selectedFeature, setSelectedFeature] = useState({});

  useEffect(() => {
    instance
      .get(`api/listing/${id}`)
      .then((res) => {
        setItem(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  useEffect(() => {
    if (item !== null) {
      setSelectedFeature((selectedFeature) => ({
        ...selectedFeature,
        street_address: item?.listingAddress,
        property_type: item?.listingType,
        listing_property_type: item?.listingPropertyType,
        square_feet: item?.listingSizeSquareFeet,
        imageLink: item?.imageLink,
        bedroom: item?.bedroomCount,
        bathroom: item?.bathroomCount,
        heat: item?.heatUtility,
        water: item?.waterUtility,
        hydro: item?.hydroUtility,
        furnished: item?.furnishedUtility,
        pet: item?.petPolicy,
        smoking: item?.smokingPolicy,
        gym: item?.gymAmenity,
        parking: item?.parkingAmenity,
        ac: item?.acAmenity,
        appliance: item?.applianceAmenity,
        storage: item?.storageAmenity,
        rent: item?.listingRent,
      }));
    }
  }, [item]);

  console.log("@slectedFeature", selectedFeature);

  const steps = [
    {
      title: "Basic Info",
      component: (
        <Basic
          data={data}
          setData={setData}
          selectedFeature={selectedFeature}
          setSelectedFeature={setSelectedFeature}
        />
      ),
    },
    {
      title: "Utilities",
      component: (
        <Utilities
          data={data}
          setData={setData}
          selectedFeature={selectedFeature}
          setSelectedFeature={setSelectedFeature}
        />
      ),
    },
    {
      title: "Policy",
      component: (
        <Policy
          data={data}
          setData={setData}
          selectedFeature={selectedFeature}
          setSelectedFeature={setSelectedFeature}
        />
      ),
    },
    {
      title: "Amenities",
      component: (
        <Amenity
          data={data}
          setData={setData}
          selectedFeature={selectedFeature}
          setSelectedFeature={setSelectedFeature}
        />
      ),
    },
  ];

  const onEdit = (e) => {
    e.preventDefault();
    setErrorMessage("");
    setLoading(true);

    instance
      .put(`/api/listings/${id}`, selectedFeature, { timeout: 600000 })
      .then((res) => {
        setLoading(false);
        setSuccessMessage("Listing Edited successfully!");
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage("Something went wrong. We couldn't add the listing.");
      });
  };

  return (
    <>
      <div className="multiStep shadow w-50 my-5 px-4 mx-auto">
        {errorMessage && (
          <p className="text-danger fs-9 mt-3 text-center pt-3">
            {errorMessage}
          </p>
        )}

        {successMessage && (
          <p className="text-success fs-9 mt-3 text-center pt-3">
            {successMessage}
          </p>
        )}

        <MultiStep
          activeStep={0}
          showNavigation={true}
          steps={steps}
          prevButton={{
            title: "Back",
            style: {
              background: "transparent",
              border: "1px solid #586bd6",
              color: "#586bd6",
              padding: ".2em 1.2em",
            },
          }}
          nextButton={{
            title: "Next",
            style: {
              background: "transparent",
              border: "1px solid #586bd6",
              color: "#586bd6",
              padding: ".2em 1.2em",
              margin: "2em 1em 0 1em",
            },
          }}
        />

        <div className="d-flex justify-content-center align-items-center">
          {loading ? <Loading /> : ""}
          <Button
            onClick={onEdit}
            className="justify-content-center px-2 py-2 bg-primary-color border-0 rounded-0  ms-2 fs-9 my-3"
            disabled={loading || successMessage !== "" ? true : false}
          >
            Edit
          </Button>
        </div>
      </div>
    </>
  );
};

export default Edit;

export const Basic = ({
  data,
  setData,
  selectedFeature,
  setSelectedFeature,
}) => {
  const addressChange = (e) => {
    setSelectedFeature((selectedFeature) => ({
      ...selectedFeature,
      street_address: e?.target?.value,
    }));
    // setData((data) => ({ ...data, address: e?.target?.value }));
  };

  const handleRetrieve = (feature) => {
    setData((data) => ({
      ...data,
      address: feature?.features[0]?.properties?.full_address,
    }));
    setSelectedFeature((selectedFeature) => ({
      ...selectedFeature,
      street_address: feature?.features[0]?.properties?.full_address,
    }));
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <Dropdown
          className={"me-2"}
          options={data?.property_type}
          title="Property Type"
          name="property_type"
          value={selectedFeature?.property_type || ""}
          onChange={(e) =>
            setSelectedFeature((selectedFeature) => ({
              ...selectedFeature,
              property_type: e?.target?.value,
            }))
          }
          edit={true}
        />
        <Dropdown
          // className={"mx-2"}
          options={data?.listing_property_type}
          title="Listing Property Type"
          name="listing_property_type"
          value={selectedFeature?.listing_property_type || ""}
          onChange={(e) =>
            setSelectedFeature((selectedFeature) => ({
              ...selectedFeature,
              listing_property_type: e?.target?.value,
            }))
          }
          edit={true}
        />
      </div>
      <div className="d-flex justify-content-between align-items-center mt-2">
        <Dropdown
          className={"me-2"}
          options={data?.bedroom}
          title="Bedroom"
          name="bedroom"
          value={selectedFeature?.bedroom || ""}
          onChange={(e) =>
            setSelectedFeature((selectedFeature) => ({
              ...selectedFeature,
              bedroom: parseInt(e?.target?.value),
            }))
          }
          edit={true}
        />
        <Dropdown
          options={data?.bath}
          title="Baths"
          name="bathroom"
          value={selectedFeature?.bathroom || ""}
          onChange={(e) =>
            setSelectedFeature((selectedFeature) => ({
              ...selectedFeature,
              bathroom: parseInt(e?.target?.value),
            }))
          }
          edit={true}
        />
      </div>
      <div>
        <div className="my-4 custom-border d-flex justify-content-between">
          <div className="w-100 autocomplete-address">
            <AddressAutofill
              onRetrieve={handleRetrieve}
              accessToken={
                "pk.eyJ1Ijoia3JpdGlrYWtvaXJhbGEiLCJhIjoiY2x0enhmaWRmMDU1eTJrb21hYXliN3ZyOSJ9.QZJhgU5tMeANennF48VcpA"
              }
            >
              <input
                className="form-control border-0 border-bottom rounded-0 fs-8 py-1 px-0 w-100"
                name="address"
                placeholder="Type your postal address like 5672 Cornel st...."
                type="text"
                autoComplete="address-line1"
                onChange={addressChange}
                value={selectedFeature?.street_address}
                // defaultValue={selectedFeature?.street_address}
              />
            </AddressAutofill>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <label class="form-label" for="square_feet">
              Sqaure Ft
            </label>

            <input
              className="form-control"
              placeholder="Listing Sq ft"
              type="number"
              name="square_feet"
              id="square_feet"
              value={selectedFeature?.square_feet || ""}
              onChange={(e) =>
                setSelectedFeature((selectedFeature) => ({
                  ...selectedFeature,
                  square_feet: parseInt(e?.target?.value),
                }))
              }
            />
          </div>
          <div className="mx-2">
            <label class="form-label" for="rent">
              Listing Rent
            </label>

            <input
              className="form-control "
              placeholder="Rent"
              type="number"
              id="rent"
              name="rent"
              value={selectedFeature?.rent || ""}
              onChange={(e) =>
                setSelectedFeature((selectedFeature) => ({
                  ...selectedFeature,
                  rent: parseInt(e?.target?.value),
                }))
              }
            />
          </div>

          <div>
            <label class="form-label" for="imageLink">
              Image Link
            </label>
            <input
              className="form-control "
              placeholder="Image Link"
              type="text"
              name="imageLink"
              id="imageLink"
              value={selectedFeature?.imageLink || ""}
              onChange={(e) =>
                setSelectedFeature((selectedFeature) => ({
                  ...selectedFeature,
                  imageLink: e?.target?.value,
                }))
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const Utilities = ({ selectedFeature, setSelectedFeature }) => {
  const allUtilities = ["heat", "water", "hydro", "furnished"];

  const utilityChange = (e) => {
    const { name, value, checked } = e?.target;
    console.log(checked);
    // console.log(data);

    setSelectedFeature((selectedFeature) => ({
      ...selectedFeature,
      [value]: checked ? "1" : "0",
    }));
  };

  return (
    <div className="d-flex justify-content-center align-items-center flex-wrap">
      {allUtilities?.map((utility, idx) => {
        return (
          <div class="form-check form-check-inline" onChange={utilityChange}>
            <input
              class="form-check-input"
              type="checkbox"
              id={idx}
              value={utility}
              name={utility}
              checked={selectedFeature[utility] === "1" ? true : false}
            />
            <label class="form-check-label text-capitalize fs-8" for={idx}>
              {utility}
            </label>
          </div>
        );
      })}
    </div>
  );
};
export const Policy = ({ selectedFeature, setSelectedFeature }) => {
  const allPolicies = ["pet", "smoking"];

  const policyChange = (e) => {
    const { name, value, checked } = e?.target;

    setSelectedFeature((selectedFeature) => ({
      ...selectedFeature,
      [value]: checked ? "1" : "0",
    }));
  };
  return (
    <div className="d-flex justify-content-center align-items-center flex-wrap">
      {allPolicies?.map((policy, idx) => {
        return (
          <div class="form-check form-check-inline" onChange={policyChange}>
            <input
              class="form-check-input"
              type="checkbox"
              id={idx}
              value={policy}
              name={policy}
              checked={selectedFeature[policy] === "1" ? true : false}
            />
            <label class="form-check-label text-capitalize fs-8" for={idx}>
              {policy}
            </label>
          </div>
        );
      })}
    </div>
  );
};
export const Amenity = ({ selectedFeature, setSelectedFeature }) => {
  const allAmenities = ["gym", "parking", "ac", "appliance", "storage"];

  const onamenityChange = (e) => {
    const { name, value, checked } = e?.target;

    setSelectedFeature((selectedFeature) => ({
      ...selectedFeature,
      [value]: checked ? "1" : "0",
    }));
  };
  return (
    <div className="d-flex justify-content-center align-items-center flex-wrap">
      {" "}
      {allAmenities?.map((amenity, idx) => {
        return (
          <div class="form-check form-check-inline" onChange={onamenityChange}>
            <input
              class="form-check-input"
              type="checkbox"
              id={idx}
              value={amenity}
              name={amenity}
              checked={selectedFeature[amenity] === "1" ? true : false}
            />
            <label class="form-check-label text-capitalize fs-8" for={idx}>
              {amenity}
            </label>
          </div>
        );
      })}
    </div>
  );
};
